var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37,11.81a1.09,1.09,0,0,0-1.09,1.1v5.31a1.1,1.1,0,0,0,2.19,0V12.91A1.09,1.09,0,0,0,6.37,11.81Z",
    style: {
      fill: "#5f6b78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.61,11.81a1.09,1.09,0,0,0-1.09,1.1v5.31a1.1,1.1,0,0,0,2.2,0V12.91A1.11,1.11,0,0,0,23.61,11.81Z",
    style: {
      fill: "#5f6b78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46,11.81v9.85a1.65,1.65,0,0,0,1.65,1.65h1.76V26.1a1.1,1.1,0,0,0,2.2,0V23.31h1.87V26.1a1.11,1.11,0,0,0,2.21,0V23.31h1.76a1.65,1.65,0,0,0,1.65-1.65v-9.8s0,0,0,0Z",
    style: {
      fill: "#5f6b78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.21,5.13,19.38,3l-.24-.14L18,5a6.39,6.39,0,0,0-3-.71,6.59,6.59,0,0,0-2.83.64L11.05,2.81,10.81,3,12,5.06a6.5,6.5,0,0,0-3.44,5.7h13A6.56,6.56,0,0,0,18.21,5.13ZM11.66,8.25A.62.62,0,0,1,11,7.63a.62.62,0,1,1,1.24,0A.62.62,0,0,1,11.66,8.25Zm6.59,0a.61.61,0,0,1-.61-.62.61.61,0,1,1,1.22,0A.61.61,0,0,1,18.25,8.25Z",
    style: {
      fill: "#5f6b78"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android_icon.909534b1a4c7d4fac758726a0485d7d2.svg";
export { ForwardRef as ReactComponent };